module.exports = __webpack_public_path__ + "static/media/SFProText-Medium.a260cbc1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-Medium.ttf
// module id = 2550
// module chunks = 7